module.exports = "<h5 class=\"text-uppercase chart-header\">Total Disposable income of major chinese cities</h5>\r\n<nav-links-legend></nav-links-legend>\r\n<div id=\"scatterplot\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/emxd-charts/scatterplot/scatterplot.html
// module id = 117
// module chunks = 0